import { common } from "./modules/common";
import { accordion } from "./modules/accordion";
import { formTopCal } from "./modules/template-parts/formTopCal";
import { calenderOrikomi } from "./modules/template-parts/calenderOrikomi";
import { customSlick } from "./modules/customSlick";
import { sumakomiCircle } from "./modules/template-parts/map/circle";
import { sumakomiGeocoder } from "./modules/template-parts/map/geocoder";
import { sumakomiMain } from "./modules/template-parts/map/main";
import { sumakomiMap } from "./modules/template-parts/map/map";
import { formSumakomi } from "./modules/template-parts/formSumakomi";
import { formOrikomi } from "./modules/template-parts/formOrikomi";
import { formCalTotal } from "./modules/template-parts/formCalTotal";
import { cf7 } from "./modules/cf7";

document.addEventListener("DOMContentLoaded", () => {

  common();
  accordion();
  customSlick();
  cf7();

  // トップページのみ読み込み
  if ($('body').hasClass('home')) {
    formTopCal();
    calenderOrikomi();
  }

  // 見積もり計算ページのみ読み込み
  if ($('body').hasClass('page-id-2820')) {

    // 折込フォーム
    formOrikomi();
    // 折込フォーム ここまで
    // スマコミ
    sumakomiMap();
    sumakomiCircle();
    sumakomiGeocoder();
    sumakomiMain();
    formSumakomi();
    // スマコミ ここまで
  }

});

window.addEventListener("load", () => {
  if ($('body').hasClass('page-id-2820')) {
    // 見積もりの確認ページへいくフォーム
    formCalTotal();
  }
});
